var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.287.287c.353-.353.909-.38 1.293-.082l.093.082 14.04 14.04c.383.383.383 1.003 0 1.386-.353.353-.909.38-1.293.082l-.093-.082L.287 1.673C-.096 1.29-.096.67.287.287z",
    transform: "translate(-976 -297) translate(430 277) translate(526) translate(20 20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.327.287c.383-.383 1.003-.383 1.386 0 .353.353.38.909.082 1.293l-.082.093-14.04 14.04c-.383.383-1.003.383-1.386 0-.353-.353-.38-.909-.082-1.293l.082-.093L14.327.287z",
    transform: "translate(-976 -297) translate(430 277) translate(526) translate(20 20)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBlack);
export default __webpack_public_path__ + "static/media/close-black.c18abd8412ad9b7bf969e29fcb2a9385.svg";
export { ForwardRef as ReactComponent };